import EmailVerified from '@/components/auth/email-verified';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/email-verified')({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      token: search.token as string | undefined,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <EmailVerified />;
}
